import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getStudents, getQR, getClass } from "../services/APIClient";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import GradeCard from "./GradeCard"; // Import your GradeCard component
import "./ClassCard.css";

function ClassCard(props) {
  // Access props directly without destructuring
  let classDetails = props.classDetails;
  let filteredClassObjects = props.filteredClassObjects;
  let schoolid = props.schoolid;
  let rollNumber = props.rollNumber;
  let teacherEmail = props.teacherEmail;
  let teachers = props.teachers;
  let teacherRoles = props.teacherRoles;
  let teacherid = props.teacherid;
  let teacherName = props.teacherName;
  let needsClaiming = props.needsClaiming;

  // Variables extracted from classDetails
  let name = classDetails.name;
  let gradeLevel = classDetails.grade_level;
  let classid = classDetails.id;
  let gradeLevel1 = classDetails.grade_level1;
  let gradeLevel2 = classDetails.grade_level2;
  let gradeLevel3 = classDetails.grade_level3; // Add support for grade level 3
  let trialClass = classDetails.trial_class;
  let specialEdClass = classDetails.specialed_class;
  let isAccessRestricted = props.isAccessRestricted;
  let isPilot = props.isPilot;
  let setClass = classDetails.set_class;
  const listedStudentNumber = Number.isFinite(classDetails.studentNumber)
    ? classDetails.studentNumber
    : 0;

  // State for storing students data, QR code details, and group details
  let [studentsResponse, setStudentsResponse] = useState(null);
  let [qrCodeDetails, setQRCodeDetails] = useState("");
  let [sharedWith, setSharedWith] = useState("");

  // Fetch students, QR code details, and group details with error handling
  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const [studentsResponse, qrResponse, classResponse] = await Promise.allSettled([
          getStudents(classid),
          getQR(classid),
          getClass(classid)
        ]);

        if (studentsResponse.status === 'fulfilled') {
          setStudentsResponse(studentsResponse.value);
        } else {
          console.error("Error fetching students:", studentsResponse.reason);
          setStudentsResponse(null);
        }

        if (qrResponse.status === 'fulfilled') {
          setQRCodeDetails(qrResponse.value);
        } else {
          console.error("Error fetching QR code details:", qrResponse.reason);
          setQRCodeDetails("");
        }

        if (classResponse.status === 'fulfilled') {
          setSharedWith(classResponse.value.sharedWith);
        } else {
          console.error("Error fetching class details:", classResponse.reason);
          setSharedWith("");
        }
      } catch (error) {
        console.error("Error fetching class data:", error);
        // Set default values to prevent crashes
        setStudentsResponse(null);
        setQRCodeDetails("");
        setSharedWith("");
      }
    };

    if (classid) {
      fetchClassData();
    }
  }, [classid]);

  // Check if the class name is in the filteredClassObjects, excluding names containing '24-'
  let isNameInFiltered = filteredClassObjects.some(
    (filteredClass) =>
      filteredClass.name === name && !filteredClass.name.includes("24-")
  );

  // Combine students and additionalStudents into one array
  let students = [
    ...(studentsResponse?.students || []),
    ...(studentsResponse?.additionalStudents || []),
  ];
  const studentCount = studentsResponse ? students.length : listedStudentNumber;

  // Dynamic helper functions
  const getCardClassName = () => {
    if (trialClass) return "trial-card-detail";
    if (specialEdClass) return "specialed-card-detail";
    if (setClass) return "set-card-detail";
    if (needsClaiming) return "claiming-card-detail";
    return "card-detail";
  };

  const getTextClassName = (baseClass = "class-card-text") => {
    if (trialClass) return "trial-class-card-text";
    if (specialEdClass) return "specialed-class-card-text";
    if (setClass) return "set-class-card-text";
    if (needsClaiming) return "claiming-class-card-text";
    return baseClass;
  };

   {/* {needsClaiming  ? (
          <Link
            className="link"
            to={`/class/settings/special`}
            state={{
              classDetails: { classDetails },
              teachers: { teachers },
              sharedWith: { sharedWith },
              name: { name },
              gradeLevel: { gradeLevel },
              students: { students },
              qrCodeDetails: { qrCodeDetails },
              schoolid: { schoolid },
            }}
          >
            {renderClassImage()}
            <div>
              <p
                className={`${
                  gradeLevel1 ? "grade-level-blue" : "grade-level-purple"
                }`}
              >
                {gradeLevel}
              </p>
              {students?.length !== undefined ? (
                <p
                  className={`${
                    specialEdClass
                      ? "specialed-class-card-text"
                      : "class-card-text"
                  }`}
                >
                  <img
                    src="./assets/imgs/child.png"
                    className="class-card-img"
                    alt="Student Image"
                  />
                  x {students.length}
                </p>
              ) : (
                <>
                  <br />
                  <p
                    className={`${
                      specialEdClass
                        ? "specialed-class-card-text"
                        : "class-card-text"
                    }`}
                  >
                    {needsClaiming 
                      ? "This class needs a teacher assigned"
                      : "Click here to add students to your class."
                    }
                  </p>
                </>
              )}
            </div>
            <p
              className={`${
                trialClass
                  ? "trial-class-card-text"
                  : specialEdClass
                  ? "specialed-class-card-text"
                  : needsClaiming
                  ? "claiming-class-card-text" 
                  : "class-card-text"
              }`}
            >
              {name}
            </p>
          </Link>
        ) : ( */}


  // Function to render the class image or claiming message
  const renderClassImage = () => {
    if (needsClaiming) {
      return (
        <div className="claiming-message">
          Please Assign Classroom Owner
        </div>
      );
    }

    return (
      <img
        src="./assets/imgs/Asset-class.webp"
        className="class-card-img"
        alt="Class Image"
        onError={(e) => {
          e.target.style.display = 'none';
          console.error("Failed to load class card image");
        }}
      />
    );
  };

  // Common content component to reduce duplication
  const CardContent = () => (
    <>
      {renderClassImage()}
      <div>
        {/* Use the GradeCard component */}
        <GradeCard 
          gradeLevel={gradeLevel}
          gradeLevel1={gradeLevel1}
          gradeLevel2={gradeLevel2}
          gradeLevel3={gradeLevel3}
          trialClass={trialClass}
        />
        
        {students?.length !== undefined ? (
          <p className={getTextClassName()}>
            <img
              src="./assets/imgs/child.png"
              className="class-card-img"
              alt="Student Image"
            />
            x {studentCount}
          </p>
        ) : (
          <>
            <br />
            <p className={getTextClassName()}>
              {needsClaiming
                ? "This class needs a teacher assigned"
                : "Click here to add students to your class."
              }
            </p>
          </>
        )}
      </div>
      <p className={getTextClassName()}>
        {name}
      </p>
    </>
  );

  return (
    <Col className="col-4">
      <Card className={getCardClassName()}>
        {needsClaiming ? (
          <div
            className="link"
            onClick={(e) => {
              e.preventDefault();
              if (props.onCardClick) {
                props.onCardClick(classDetails);
              }
            }}
            style={{ cursor: 'pointer' }}
          >
            <CardContent />
          </div>
        ) : (
          <Link
            className="link"
            to={`/class/detail`}
            state={{
              classDetails: { classDetails },
              teachers: { teachers },
              name: { name },
              gradeLevel: { gradeLevel },
              rollNumber: { rollNumber },
              teacherEmail: { teacherEmail },
              schoolid: { schoolid },
              isAccessRestricted: { isAccessRestricted },
              isPilot: { isPilot },
              teacherRoles: { teacherRoles },
              teacherid: { teacherid },
              teacherName: { teacherName }
            }}
          >
            <CardContent />
          </Link>
        )}
      </Card>
    </Col>
  );
}

export default ClassCard;
